import { useContext } from 'react';
import { AuthContext } from 'contexts/AuthContext';
import useHttpClient from 'hooks/useHttpsClient';
import { useNavigate } from 'react-router-dom';
import Toast from 'components/toast/Toast';

const useAuthService = () => {
  const { sendRequest } = useHttpClient();
  const { signIn, clearLocalStorage } = useContext(AuthContext);
  const navigate = useNavigate();

  const showErrorMessage = (message) => {
    Toast.error(message)
  };
  const showSuccessMessage = (message) => {
    Toast.success(message)
  };

  const login = async ({ email, password }) => {
    try {
      const response = await sendRequest('/custom-auth/login', 'post', { identifier: email, password });

      if (response.data && response.data.jwt) {
        const { jwt, user } = response.data;
        signIn({ token: jwt, user });
        console.log("Welcome");
        showSuccessMessage("Welcome to RH Dashboard")
        navigate('/');
      } else {
        console.log("Wrong credentials");
        showErrorMessage("Login failed. Please check your credentials and try again.");
      }
    } catch (err) {
      console.error("Authentication error", err);
      showErrorMessage("Login failed. Please check your credentials and try again.");
    }
  };

  const logout = () => {
    clearLocalStorage();
    navigate('/login');
  };

  return { login, logout };
};

export default useAuthService;